import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ViewModeComponent as VC } from '@fantaz/ui/view-mode';
import { ViewModeComponent } from './view-mode.component';

@NgModule({
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonToggleModule,
    MatIconModule,
    VC,
  ],
  declarations: [ViewModeComponent],
  exports: [ViewModeComponent],
})
export class TournamentsViewModeModule {}
